<div
  class="pro-card"
  [ngClass]="{ flex32: flex == '3-2', flex41: flex == '4-1' }"
  >
  <div class="pro-card-info">
    @for (info of infoContent; track info) {
      <span class="info-content"
        ><strong>{{ info.label }}:</strong>
        @if (isArray(info.value)) {
          <div class="array-row">
            @for (item of info.value; track item) {
              <span>
                {{ item }}
              </span>
            }
          </div>
        } @else {
          {{ info.value }}
        }
        </span
        >
      }
    </div>
    <div class="vertical-separator"></div>
    <div class="pro-card-status">
      <div class="status-list">
        @for (status of statusContent | slice : 0 : 3; track status) {
          <app-status-badge
            class="status-badge"
            [text]="status.label"
            [status]="status.value"
            [size]="statusContent.length == 1 ? 'large' : badgeSize"
            />
        }
        @if (statusContent.length > 3) {
          <app-status-badge
            class="status-badge"
            [text]="getExtraCount()"
            [status]="'primary'"
            [size]="badgeSize"
            />
        }
      </div>
      <div class="item-detail">
        <button (click)="goDetail()" type="button">
          <span class="material-icons-outlined icon">visibility</span>
        </button>
      </div>
    </div>
  </div>
